<mat-card class="decoration-card">
    <mat-card-content>

        <mat-toolbar *ngIf="!isReadonly">

            <span class="example-spacer"></span>

            <button mat-icon-button matTooltip="add a personal" (click)="createPersonal()" *ngIf="!isReadonly">
                <mat-icon>plus_one</mat-icon>
            </button>
        </mat-toolbar>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition" -->

            <!-- name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <!-- position Column -->
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef> Position </th>
                <td mat-cell *matCellDef="let element"> {{element.position}} </td>
            </ng-container>

            <!-- company Column -->
            <ng-container matColumnDef="company">
                <th mat-header-cell *matHeaderCellDef> Company </th>
                <td mat-cell *matCellDef="let element"> {{element.company}} </td>
            </ng-container>

            <!-- certificate Column -->
            <ng-container matColumnDef="certificate">
                <th mat-header-cell *matHeaderCellDef> Certificate </th>
                <td mat-cell *matCellDef="let element"> {{element.certificate}} </td>
            </ng-container>

            <!-- remarks Column -->
            <ng-container matColumnDef="remarks">
                <th mat-header-cell *matHeaderCellDef> Remarks </th>
                <td mat-cell *matCellDef="let element"> {{element.remarks}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row (click)="selectTrailPersonal(row)" *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </mat-card-content>
</mat-card>